import React, { useEffect } from 'react'
import { AppState } from 'react-native'

import NetInfo from '@react-native-community/netinfo'

import { navigateBack, navigateTo } from './navigation'

const navigateToNetworkIssue = () =>
  setTimeout(() => navigateTo('NetworkIssueScreen'), 500)

const NetworkListener = () => {
  const isNetworkIssueScreenVisible = React.useRef<any>(false)

  useEffect(() => {
    const unsubscribeNetwork = NetInfo.addEventListener((state) => {
      if (
        !state.isInternetReachable &&
        !state.isConnected &&
        AppState.currentState === 'active'
      ) {
        isNetworkIssueScreenVisible.current = true
        navigateToNetworkIssue()
      } else if (
        state.isInternetReachable &&
        state.isConnected &&
        isNetworkIssueScreenVisible.current
      ) {
        isNetworkIssueScreenVisible.current = false
        navigateBack()
      }
    })

    const unsubscribeAppState = AppState.addEventListener('change', (state) => {
      if (state === 'active')
        NetInfo.refresh().catch((err) => console.log('err', err))
    })

    return () => {
      unsubscribeNetwork()
      unsubscribeAppState.remove()
    }
  }, [])

  return <></>
}

export default NetworkListener
